/* Ellevate Imagery theme behaviour. Progressive enhancement only: every form still submits natively. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setHeaderHeight() {
    var h = document.querySelector('.ev-header');
    if (h) {
      document.documentElement.style.setProperty('--ev-header-h', h.offsetHeight + 'px');
      document.documentElement.style.setProperty('--ev-menu-top', h.getBoundingClientRect().bottom + 'px');
    }
  }

  function initMenu() {
    var menu = document.querySelector('[data-ev-menu]');
    if (!menu) return;
    var summary = menu.querySelector('summary');
    menu.addEventListener('toggle', function () {
      setHeaderHeight();
      summary.setAttribute('aria-expanded', menu.open ? 'true' : 'false');
      document.documentElement.style.overflow = menu.open ? 'hidden' : '';
      if (menu.open) { var first = menu.querySelector('.ev-menu__panel a'); if (first) first.focus(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.open) { menu.open = false; summary.focus(); }
    });
  }

  function initReveal() {
    var els = document.querySelectorAll('.ev-io');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initFilters() {
    document.querySelectorAll('[data-ev-filter]').forEach(function (bar) {
      var scope = document.getElementById(bar.getAttribute('data-ev-filter'));
      if (!scope) return;
      var chips = bar.querySelectorAll('[data-subject]');
      var heading = bar.closest('.ev-gallery').querySelector('[data-ev-gallery-heading]');
      function apply(subject) {
        chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-subject') === subject ? 'true' : 'false'); });
        if (heading) {
          var active = Array.prototype.find.call(chips, function (c) { return c.getAttribute('data-subject') === subject; });
          heading.textContent = subject === 'all' ? heading.getAttribute('data-all-heading') : active.textContent;
        }
        scope.querySelectorAll('.ev-card').forEach(function (card) {
          var subs = (card.getAttribute('data-subjects') || '').split(' ');
          card.hidden = !(subject === 'all' || subs.indexOf(subject) > -1);
        });
        var live = bar.querySelector('[data-ev-filter-live]');
        if (live) live.textContent = scope.querySelectorAll('.ev-card:not([hidden])').length + ' artworks shown';
      }
      chips.forEach(function (c) { c.addEventListener('click', function () { apply(c.getAttribute('data-subject')); }); });
      var hash = (location.hash || '').replace('#', '');
      var match = Array.prototype.some.call(chips, function (c) { return c.getAttribute('data-subject') === hash; });
      apply(match ? hash : (bar.getAttribute('data-initial-subject') || 'all'));
    });
  }

  function initFeaturedCarousels() {
    document.querySelectorAll('.ev-gallery--featured').forEach(function (section) {
      if (section.dataset.evCarouselReady) return;
      var grid = section.querySelector('.ev-grid');
      var controls = section.querySelector('.ev-carousel-controls');
      if (!grid || !controls) return;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.ev-card'));
      if (cards.length < 2) return;
      section.dataset.evCarouselReady = 'true';
      var prev = controls.querySelector('[data-ev-carousel-prev]');
      var next = controls.querySelector('[data-ev-carousel-next]');
      var count = controls.querySelector('[data-ev-carousel-count]');
      var mobile = window.matchMedia('(max-width: 749px)');
      var index = -1;
      function update() {
        controls.hidden = !mobile.matches;
        if (!mobile.matches) {
          ['tabindex', 'role', 'aria-label', 'aria-roledescription'].forEach(function (name) { grid.removeAttribute(name); });
          return;
        }
        grid.setAttribute('tabindex', '0');
        grid.setAttribute('role', 'region');
        grid.setAttribute('aria-label', 'Featured artworks');
        grid.setAttribute('aria-roledescription', 'carousel');
        var start = grid.getBoundingClientRect().left + (parseFloat(window.getComputedStyle(grid).paddingLeft) || 0);
        var closest = 0, distance = Infinity;
        cards.forEach(function (card, i) {
          var d = Math.abs(card.getBoundingClientRect().left - start);
          if (d < distance) { distance = d; closest = i; }
        });
        if (index !== closest) {
          index = closest;
          count.textContent = (index + 1) + ' / ' + cards.length;
          count.setAttribute('aria-label', 'Artwork ' + (index + 1) + ' of ' + cards.length);
        }
        prev.disabled = index === 0;
        next.disabled = index === cards.length - 1;
      }
      function go(to) {
        if (!mobile.matches) return;
        to = Math.max(0, Math.min(cards.length - 1, to));
        var padding = parseFloat(window.getComputedStyle(grid).paddingLeft) || 0;
        grid.scrollTo({ left: grid.scrollLeft + cards[to].getBoundingClientRect().left - grid.getBoundingClientRect().left - padding, behavior: reduce ? 'auto' : 'smooth' });
      }
      prev.addEventListener('click', function () { go(index - 1); });
      next.addEventListener('click', function () { go(index + 1); });
      grid.addEventListener('scroll', update, { passive: true });
      grid.addEventListener('keydown', function (event) {
        if (!mobile.matches || event.target !== grid) return;
        var to = { ArrowLeft: index - 1, ArrowRight: index + 1, Home: 0, End: cards.length - 1 }[event.key];
        if (to === undefined) return;
        event.preventDefault(); go(to);
      });
      window.addEventListener('resize', update);
      update();
    });
  }

  function initDemoSwitch() {
    var demos = document.querySelectorAll('[data-ev-demo]');
    if (!demos.length) return;
    var want = new URLSearchParams(location.search).get('artwork');
    if (!want) return;
    var found = Array.prototype.some.call(demos, function (d) { return d.getAttribute('data-ev-demo') === want; });
    if (!found) return;
    demos.forEach(function (d) { d.hidden = d.getAttribute('data-ev-demo') !== want; });
  }

  function initQty() {
    document.querySelectorAll('[data-ev-qty]').forEach(function (q) {
      var input = q.querySelector('input');
      q.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v = b.getAttribute('data-dir') === 'up' ? v + 1 : Math.max(1, v - 1);
          input.value = v;
        });
      });
    });
  }

  function initProducts() {
    document.querySelectorAll('[data-ev-product]').forEach(function (root) {
      var dataEl = root.querySelector('[data-ev-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var strings = JSON.parse(root.querySelector('[data-ev-strings]').textContent);
      var select = root.querySelector('select[name="id"]');
      var btn = root.querySelector('[data-ev-add]');
      var priceEl = root.querySelector('[data-ev-price]');
      var status = root.querySelector('[data-ev-status]');
      var stage = root.querySelector('.ev-art__stage img');
      var fieldsets = root.querySelectorAll('[data-ev-option]');
      var form = select.closest('form');

      function current() {
        return Array.prototype.map.call(fieldsets, function (fs) {
          var c = fs.querySelector('input:checked');
          return c ? c.value : null;
        });
      }
      function find(sel) {
        return variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); });
      }
      function update(push) {
        var sel = current();
        fieldsets.forEach(function (fs, idx) {
          var out = fs.querySelector('[data-ev-chosen]');
          if (out) out.textContent = sel[idx] || '';
          fs.querySelectorAll('input').forEach(function (inp) {
            var test = sel.slice(); test[idx] = inp.value;
            var m = find(test);
            inp.closest('.ev-pill').setAttribute('data-state', !m ? 'none' : (m.available ? 'ok' : 'sold'));
          });
        });
        var v = find(sel);
        if (!v) {
          select.value = '';
          select.disabled = true;
          btn.disabled = true; btn.querySelector('span').textContent = strings.unavailable;
          priceEl.innerHTML = '<span>' + strings.unavailable + '</span>';
          status.textContent = strings.combo;
          return;
        }
        select.disabled = !v.available;
        select.value = String(v.id);
        priceEl.innerHTML = v.price + (v.compare ? ' <s>' + v.compare + '</s>' : '') + '<small>' + strings.taxNote + '</small>';
        if (v.available) {
          btn.disabled = false; btn.querySelector('span').textContent = strings.add; status.textContent = '';
        } else {
          btn.disabled = true; btn.querySelector('span').textContent = strings.soldOut; status.textContent = strings.soldOutMsg;
        }
        if (v.image && stage) { stage.src = v.image; stage.removeAttribute('srcset'); }
        if (push && window.history.replaceState) {
          var url = new URL(location.href); url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        }
      }
      fieldsets.forEach(function (fs) { fs.addEventListener('change', function () { update(true); }); });
      form.addEventListener('submit', function (event) {
        var variant = variants.find(function (item) { return String(item.id) === select.value; });
        if (btn.disabled || select.disabled || !variant || !variant.available) {
          event.preventDefault();
          status.textContent = strings.combo;
        }
      });
      if (fieldsets.length) update(false);

      root.querySelectorAll('[data-ev-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          if (!stage) return;
          stage.src = t.getAttribute('data-ev-thumb'); stage.removeAttribute('srcset');
          stage.alt = t.querySelector('img').alt;
          root.querySelectorAll('[data-ev-thumb]').forEach(function (o) { o.setAttribute('aria-current', o === t ? 'true' : 'false'); });
        });
      });
    });
  }

  function initCornerPlacement() {
    var corner = document.querySelector('.ev-afterpay-corner');
    if (!corner) return;
    function previewBar() {
      return document.getElementById('PBarNextFrameWrapper')
        || document.getElementById('PBarNextFrame')
        || document.getElementById('preview-bar-iframe');
    }
    function align() {
      var bar = previewBar();
      var rect = bar && bar.getBoundingClientRect();
      var visible = bar && window.getComputedStyle(bar).visibility !== 'hidden';
      var overlapsCorner = rect && rect.left < (corner.offsetWidth || 184) && rect.right > 0;
      var height = visible && overlapsCorner && rect.height > 0 && rect.bottom >= window.innerHeight - 32
        ? Math.max(0, window.innerHeight - rect.top) : 0;
      var bottom = height + 'px';
      if (corner.style.bottom !== bottom) corner.style.bottom = bottom;
    }
    function watchBar() {
      var bar = previewBar();
      if (!bar) return false;
      if (window.ResizeObserver) new window.ResizeObserver(align).observe(bar);
      if (window.MutationObserver) new window.MutationObserver(align).observe(bar, { attributes: true });
      align();
      return true;
    }
    align();
    window.addEventListener('resize', align);
    if (!watchBar() && window.MutationObserver) {
      var finder = new window.MutationObserver(function () {
        if (watchBar()) finder.disconnect();
      });
      finder.observe(document.body, { childList: true, subtree: true });
    }
  }

  function initNewsletter() {
    document.querySelectorAll('[data-ev-newsletter]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        // Use Klaviyo's supported openForm API, never a form's submit button.
        // If the provider is blocked, the normal link opens the same-list hosted signup page.
        if (window._klOnsite && typeof window._klOnsite.push === 'function') {
          event.preventDefault();
          window._klOnsite.push(['openForm', link.getAttribute('data-klaviyo-form')]);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setHeaderHeight(); initMenu(); initReveal(); initFilters(); initFeaturedCarousels(); initDemoSwitch(); initQty(); initProducts(); initCornerPlacement(); initNewsletter();
  });
  document.addEventListener('shopify:section:load', initFeaturedCarousels);
  window.addEventListener('resize', setHeaderHeight);
})();
